<template>
    <div class="items-content">
        <div class="title">{{ detail.title }}</div>
        <to-top></to-top>
        <ckeditor-content :content="detail.content"></ckeditor-content>
    </div>
</template>

<script>
import ajax from '@/api/ajax'
import toTop from '@/components/to-top'
import ckeditorContent from '@/components/ckeditor-content'
export default {
    name: 'PrivacyPolicy',
    components: {
        ckeditorContent,
        toTop
    },
    data() {
        return {
            detail: {}
        }
    },
    async created() {
        const params = this.$route.meta.apiParams || {}
        this.$route.meta.cmsApi &&
            ajax[this.$route.meta.cmsApi]({ params }).then(res => {
                if (Array.isArray(res)) {
                    this.detail = res[0]
                } else {
                    this.detail = res
                }
            })
    }
}
</script>

<style lang="scss" scoped>
.items-content {
    .title {
        line-height: 0.88rem;
        height: 0.88rem;
        font-size: 0.3rem;
        font-weight: bold;
        text-align: center;
        background: #f1f1f1;
    }
    .content {
        margin-top: 0.4rem;
        padding: 0 0.2rem;
        padding-bottom: 0.4rem;
        position: relative;
        >>> h2 {
            font-size: 0.34rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/items-content/index.vue